import { ReturnProps } from 'components/Shared/VerifiedPayments/Contexts/TracingContext';
import { useContext } from 'react';
import { TracingContext } from '../Contexts';

const useTracing = (): ReturnProps => {
  return useContext(TracingContext);
};

export default useTracing;
